import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PaymentsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"payments"}/>
}
